import React from 'react'

const ImageCards = () => {
  // Array of image card data
  const cards = [
    {
      title: 'Valerian Extract',
      src: 'https://cdn.blackincae.com/z1w-valerian-extract-l-otto.png',
    },
    {
      title: 'Chamomile Extract',
      src: 'https://cdn.blackincae.com/QEd-chamomile-extract-l-otto.png',
    },
    {
      title: 'Lemon Balm Extract',
      src: 'https://cdn.blackincae.com/RQ6-lemon-balm-extract-l-otto.png',
    },
    {
      title: 'Passion Flower Extract',
      src: 'https://cdn.blackincae.com/dAL-passion-flower-extract-l.png',
    },
    {
      title: 'GABA',
      src: 'https://cdn.blackincae.com/AHA-gaba-l-otto.png',
    },
    {
      title: 'L-Tryptophan',
      src: 'https://cdn.blackincae.com/B4g-l-tryptophan-l-otto.png',
    },
    {
      title: 'Melatonin',
      src: 'https://cdn.blackincae.com/fnC-melatonin-l-otto.png',
    },
  ]

  return (
    <>
      <div className="text-black flex items-center gap-4 justify-center pt-2">
        <div className="text-[26px] text-start max-w-lg text-[#233751] italic font-bold bold-font">
          I’m talking about...
        </div>
      </div>

      {/* Grid for cards */}
      <div className="mx-auto max-w-5xl flex">
        <div className="grid md:gap-6 gap-3 md:grid-cols-4 grid-cols-2 mx-auto max-w-5xl px-3 pt-10">
          {cards.slice(0, 4).map((item, index) => (
            <div
              key={index}
              className="rounded-[12px] overflow-hidden max-w-xs w-full transition-transform duration-300 hover:scale-105 border border-white bg-[#EFF6FF]"
              style={{ boxShadow: '0px 1px 4px 0px rgba(0, 0, 0, 0.15)' }}
            >
              <div className="px-3 py-2 flex flex-col items-center justify-center bg-[#EFF6FF]">
                <div className="w-32 h-32 rounded-full overflow-hidden flex items-center justify-center">
                  <img
                    src={item.src}
                    alt={item.title}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="text-center bg-[#EFF6FF]">
                  <h3 className="text-[18px] font-semibold text-[#233751] italic">
                    {item.title}
                  </h3>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Second grid */}
      <div className="mx-auto max-w-5xl flex">
        <div className="grid md:gap-6 gap-3 md:grid-cols-3 grid-cols-2 mx-auto max-w-5xl px-3 pt-3">
          {cards.slice(4, 7).map((item, index) => (
            <div
              key={index}
              className={`rounded-[12px] overflow-hidden max-w-xs w-full transition-transform duration-300 hover:scale-105 border border-white bg-[#EFF6FF] px-3 ${
                item.title === 'Melatonin' ? 'hidden md:block' : ''
              }`}
              style={{ boxShadow: '0px 1px 4px 0px rgba(0, 0, 0, 0.15)' }}
            >
              <div className="px-5 md:px-4 py-2 flex flex-col items-center justify-center bg-[#EFF6FF]">
                <div className="w-32 h-32 rounded-full overflow-hidden flex items-center justify-center">
                  <img
                    src={item.src}
                    alt={item.title}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="text-center bg-[#EFF6FF]">
                  <h3 className="text-[18px] font-semibold text-[#233751] italic">
                    {item.title}
                  </h3>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Mobile-only Melatonin card */}
      <div className="mx-auto max-w-5xl flex block md:hidden">
        <div className="grid md:gap-6 gap-3 md:grid-cols-3 grid-cols-1 mx-auto max-w-5xl px-3 pt-3">
          {cards
            .filter((item) => item.title === 'Melatonin')
            .map((item, index) => (
              <div
                key={index}
                className="rounded-[12px] overflow-hidden max-w-xs w-full transition-transform duration-300 hover:scale-105 border border-white bg-[#EFF6FF] px-3"
                style={{ boxShadow: '0px 1px 4px 0px rgba(0, 0, 0, 0.15)' }}
              >
                <div className="px-3 py-2 flex flex-col items-center justify-center bg-[#EFF6FF]">
                  <div className="w-32 h-32 rounded-full overflow-hidden flex items-center justify-center">
                    <img
                      src={item.src}
                      alt={item.title}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="text-center bg-[#EFF6FF]">
                    <h3 className="text-[18px] font-semibold text-[#233751] italic">
                      {item.title}
                    </h3>
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>
    </>
  )
}

export default ImageCards
